<!-- Banner -->
<article class="banner ">

    <!-- Desktop Banner -->
    <div class="row banner__box hidebelow900">
        <div class="banner__box--info">
            <span class="time__left text-lowercase"
                    *ngIf="activationInfo?.completionDaysLeft && activationInfo?.enableProgramTimer">
                    {{program[0]?.totalDuration | formateSeconds:'hourMinute'}}
                </span>
            <h3 class="light-color">{{activationInfo?.title}}
                <span class="time__left text-lowercase"
                    *ngIf="activationInfo?.completionDaysLeft && activationInfo?.enableProgramTimer">
                    {{program[0]?.totalDuration | formateSeconds:'hourMinute'}}
                </span>
            </h3>
            
            <p class="light-color">
                <span class="cursor-pointer" (click)="openDescriptionModal()" [ngStyle]="{'height':activationInfo.description.length > 95 ? '65px' :'30px'}">{{activationInfo?.description}}
                </span>
                <!-- <a [ngStyle]="{'align-items':prog.description.length > 195 ? 'end' :'start','cursor': 'pointer'}" (click)="openDescriptionModal()">View Full Information</a> -->
            </p>

            <div class="banner_box--learning ">
                <div class="banner_box--progress-bar"
                    *ngIf="activationInfo && activationInfo?.totalDuration && (activationInfo?.totalDuration > 0)">
                    <label for="progressbar">
                        Progress:
                        <span *ngIf="!activationInfo?.progress">0%</span>
                        <span *ngIf="activationInfo?.progress">{{activationInfo?.progress| number:'1.0-2'}} %</span>
                    </label>
                    <progress  id="file" [value]="activationInfo?.progress| number: '1.0-2'" max="100"> </progress>
                </div>

               
                <div class="banner_box--progress-bar"
                    *ngIf="activationInfo && activationInfo?.totalDuration && (activationInfo?.totalDuration > 0)">
                    <label for="progressbar">
                        Time Left: 
                        <span style="text-transform: capitalize;">
                            {{activationInfo?.completionDaysLeft + (activationInfo?.completionDaysLeft > 1? ' Days':' Day')}}
                        </span>
                        <!-- <br/>
                        <span>{{program[0]?.totalDuration | formateSeconds: 'hourMinute'}}</span> -->
                    </label>
                    <progress class="rtl" id="file" [value]="(((activationInfo?.completionDaysLeft)/activationInfo?.totalDays)*100)| number:'1.0-0'" max="100"></progress>
                </div>
                <div class="banner_box--progress banner_box--current" *ngIf="activationInfo &&  activationInfo?.progress < 100 && currentCardName">
                    <label for="progressbar">{{(currentCardName == 'COMPLETED')
                        ? '' : 'Currently at:'}}<br/>

                        
                        <span *ngIf="currentCardName">{{(currentCardName | slice:0:20) + (currentCardName.length > 20 ? '...' : '') | titlecase}}</span>
                        </label>
                </div>

                <a class="banner_box--progress-cert" *ngIf="!bannerBtnTxt && !buttonReport" (click)="goToNextItem()">
                    <label> Wait for next unlock </label>
                </a>
                <a class="banner_box--progress-cert"
                    *ngIf="buttonReport &&
                        ((activationInfo.enableProgramCertificate && !isProgramCompletionDatePassed) ||
                        (activationInfo?.showProgramPerformanceReport || activationInfo?.enableProgramCertificate))"
                    (click)="goToNextItem()">
                    <ng-container
                        *ngIf="activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport">
                        <label> Certificate & Transcript</label>
                    </ng-container>
                    <div *ngIf="!(activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport)" style="color: white;padding: 7px;">
                        <ng-container
                        *ngIf="!(activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport)">
                        {{(activationInfo?.enableProgramCertificate && !isProgramCompletionDatePassed)
                        || (activationInfo?.enableProgramCertificate &&
                        program[0].status.progress == 100) ? "Certificate" : "Transcript"}}
                    </ng-container>
                    </div>
                    
                </a>
                <!-- <a class="light-color link-no-underline pd-t10 pd-b10 pd-l20 pd-r20 cursor-pointer"
                    *ngIf="program &&  program[0]?.progress < 100"> RESUME
                    LEARNING</a> -->
            </div>
            <!-- <div class="banner__box--bottom">
                <a *ngIf="bannerBtnTxt && !buttonReport" (click)="goToNextItem(true)">
                    <span class="icon icon-play-button"></span>
                    {{isProgramStarted ? 'RESUME':'START'}} LEARNING
                </a>
                <a class="banner__box--bottom-btn" (click)="openModal()" *ngIf="showIntroVideo">
                    <span class="material-symbols-outlined">
                        play_circle
                    </span>
                    Watch Program Intro
                </a>
            </div> -->
        </div>
        <div class="banner__box-buttons">
            <a *ngIf="bannerBtnTxt && !buttonReport && !showIntroVideo" (click)="goToNextItem(true)">
                <span class="icon icon-play-button"></span>
                {{isProgramStarted ? 'RESUME':'START'}} LEARNING
            </a>
            <a class="banner__box--bottom-btn" (click)="openModal()" *ngIf="showIntroVideo">
                <span class="material-symbols-outlined">
                    play_circle
                </span>
                Watch Program Intro
            </a>
        </div>
    </div>
    <!-- Popup -->
    <!-- <div class="popup-main popup--overlay">
    <div class="popup">
    <button class="popup--close" href=""><span class="icon-cross"></span></button>

        <div class="popup__content">
            <h2>Program Block Introductory Video 1</h2>
        <p>It is a long established fact that a reader will be distracted by the readable
            content of a page when looking at its layout.</p>
            <img src="assets/images/video.PNG" alt="" />
            <button class="light-color link-no-underline blue--button pd-t10 pd-b10 pd-l20 pd-r20">
                START COURSE
            </button>
        </div>
    </div>
</div> -->
    <!-- Desktop Banner -->
    <!-- Mobile Banner -->
    <div class="row banner__box hideabove900">
        <div class="banner__box--info">
            <!-- <span class="time__left"
                *ngIf="prog?.activation?.completionDaysLeft && prog?.activation?.enableProgramTimer">
                {{prog?.activation?.completionDaysLeft + (prog?.activation?.completionDaysLeft > 1? ' days':' day')+ '
                left'}}
            </span> -->
            
            <h3 class="light-color text-capitalize">{{prog?.activation?.title}}</h3>
            <p class="light-color banner_text--desc">{{prog?.description}}
            </p>
            <p class="light-color banner__box--view">
                <span class="material-symbols-outlined">
                    info
                </span> <a (click)="openDescriptionModal()">View Program Information</a>
            </p>
            <!-- Display this when course has started -->
            <div class="banner_box--learning ">
                <div class="banner_box--progress-bar"
                    *ngIf="activationInfo && activationInfo?.totalDuration && (activationInfo?.totalDuration > 0)">
                    <label for="progressbar">
                        Progress:
                        <span *ngIf="!activationInfo?.progress">0%</span>
                        <span *ngIf="activationInfo?.progress">{{activationInfo?.progress| number:'1.0-2'}} %</span>
                    </label>
                    <progress  id="file" [value]="activationInfo?.progress| number:'1.0-0'" max="100"> </progress>
                </div>
                <div class="banner_box--progress-bar"
                    *ngIf="activationInfo && activationInfo?.totalDuration && (activationInfo?.totalDuration > 0)">
                    <label for="progressbar">
                        Time Left: 
                        <span style="text-transform: capitalize;">
                            {{activationInfo?.completionDaysLeft + (activationInfo?.completionDaysLeft > 1? ' Days':' Day')}}
                        </span>
                        <!-- <br/>
                        <span>{{program[0]?.totalDuration | formateSeconds: 'hourMinute'}}</span> -->
                    </label>
                    <progress class="rtl" id="file" [value]="(((activationInfo?.completionDaysLeft)/activationInfo?.totalDays)*100)| number:'1.0-0'" max="100"></progress>
                </div>

                <div class="banner_box--progress banner_box--current" *ngIf="activationInfo &&  activationInfo?.progress <= 100 && currentCardName">
                    <!-- <div class="percent" [ngStyle]="{'left':currentCardName?.length > 35 ?'5px':'-6px'}">
                        <svg>
                            <circle cx="25" cy="25" r="20"></circle>
                            <circle cx="25" cy="25" r="20" style="--percent: {{program[0]?.progress| number:'1.0-0'}}">
                            </circle>
                        </svg>
                        <div class="number">
                            {{program[0]?.progress| number:'1.0-0'}}%
                        </div>
                    </div> -->
                    <label for="progressbar">{{(currentCardName == 'COMPLETED')
                        ? '' : 'Currently at'}}<br/>
                        <span *ngIf="currentCardName"> {{currentCardName | titlecase}}</span>
                        <!-- <span class="orange-color bold-text">{{program[0]?.progress |number:'1.0-0'}}%</span> -->
                    </label>
                    <!-- <progress id="progressbar" value="{{program[0]?.progress}}" max="100"></progress> -->
                </div>
                <!-- <div class="banner_box--progress"
                    *ngIf="program && program.length && program[0]?.totalDuration && (program[0]?.totalDuration > 0)">
                    <label for="progressbar">
                        Total Learning Time
                        <span>{{program[0]?.totalDuration | formateSeconds:
                            'hourMinute'}}</span>
                    </label>
                </div> -->
            </div>
            <!-- Display this when course has started -->
        </div>
        <div class="banner__box--bottom">
            <!-- Change the Button Text into Resume Learning when course has started -->
            <a class="" *ngIf="bannerBtnTxt && !buttonReport" (click)="goToNextItem(true)">
                <span class="icon icon-play-button"></span>
                <!-- {{(program && program[0]?.progress === undefined)? 'START':'RESUME'}} LEARNING</a> -->
                {{ isProgramStarted ? 'RESUME':'START'}} LEARNING
            </a>
            <a *ngIf="!bannerBtnTxt && !buttonReport" (click)="goToNextItem()">
                Wait for next unlock</a>
            <a *ngIf="buttonReport &&
                ((activationInfo.enableProgramCertificate && !isProgramCompletionDatePassed) ||
                (activationInfo?.showProgramPerformanceReport) || activationInfo?.enableProgramCertificate)"
                (click)="goToNextItem()">
                <ng-container
                    *ngIf="activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport">
                    Certificate & Transcript
                </ng-container>
                <div style="color: white;padding: 7px;">
                    <ng-container
                    *ngIf="!(activationInfo?.enableProgramCertificate && activationInfo?.showProgramPerformanceReport)">
                    {{(activationInfo?.enableProgramCertificate && !isProgramCompletionDatePassed) ||
                    (activationInfo?.enableProgramCertificate &&
                    program[0]?.status.progress == 100) ? "Certificate" : "Transcript"}}
                </ng-container>
                </div>
                
            </a>

            <!-- Change the Button Text into Resume Learning when course has started -->
            <a (click)="openModal()" id="popup__show--mob" class="banner__box--bottom-btn">
                <!-- <p class="banner__box--text light-color mg-r10">Watch Program Introduction</p> -->
                <span class="material-symbols-outlined">
                    play_circle
                </span>
                Intro
            </a>
        </div>
    </div>
    <!-- Mobile Banner -->
</article>
<!-- Banner -->

<app-dashboard-description-modal *ngIf="showDescriptionModal" [desc]="activationInfo?.description" (modelOpen)="closeDescriptionModel($event)"></app-dashboard-description-modal>

<app-static-player *ngIf="showBannerModal" (modelOpen)="closeModel($event)" [type]="'PROGRAM'"
    [file]="activationInfo?.introduction.videoUrl" [autoStart]="true" [isInPopup]="false"
    [thumb]="activationInfo?.introduction.videoThumbnailUrl"
    [videoTitle]="(activationInfo?.isNewActivation) ? activationInfo?.introduction?.videoTitle : activationInfo?.introduction?.videoThumbnailUrl"
    [videoDesc]="activationInfo?.introduction?.description" [programIntroVideo]="true"></app-static-player>
<app-static-player *ngIf="showProgramEndVideo" (modelOpen)="closeModelEndVideo($event)" [type]="'PROGRAM'"
    [file]="activationInfo?.onCompletion?.videoUrl" [autoStart]="true" [isInPopup]="false"
    [thumb]="activationInfo?.onCompletion?.videoThumbnailUrl"
    [videoTitle]="(activationInfo?.isNewActivation) ? activationInfo?.onCompletion?.videoTitle : activationInfo?.onCompletion?.videoThumbnailUrl"
    [videoDesc]="activationInfo?.onCompletion?.description" [programEndVideo]="true"></app-static-player>

<app-common-feedback (hideFeedback)="hideFeedback($event)" *ngIf="showFeedback" [user]="user"
    [completedItemObj]="completedItemObj" [programActivationId]="activationInfo.programActivationId">
</app-common-feedback>

<app-masterclass-threshold-modal [user]="user" (hideModal)="hideMasterClassThreshold($event)"
    *ngIf="showMasterClassThreshold"></app-masterclass-threshold-modal>

<!-- Show program completion modal -->
<app-program-completion-modal *ngIf="showProgramCompletionModal" (hideProgramModal)="hideProgCompletionModal($event)"
    [user]="user" [prog]="prog"></app-program-completion-modal>
